import { defineMessages } from 'utils/intl';

export default defineMessages({
  attributeGroupHeader: '{groupName} w {productName}',
});
